<template>
  <div
    v-if="!isDismissed"
    class="px-6 pb-4"
    data-testid="flows-shared-only-banner"
  >
    <div class="flex items-center justify-between rounded-lg border border-default bg-muted p-4">
      <p class="text-sm text-subtle mb-0">
        {{ bannerMessage }}
      </p>
      <button
        type="button"
        class="bg-transparent border-none ml-4 shrink-0 text-sm text-subtle underline hover:text-emphasis"
        @click="dismiss"
      >
        Dismiss
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

function getStorageKey(accountSlug, appSlug) {
  return `flows_banner_dismissed_sharedOnly_${accountSlug}_${appSlug}`;
}

export default {
  name: 'FlowsSharedOnlyBanner',
  props: {
    appName: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      isDismissed: false,
    };
  },
  computed: {
    ...mapGetters(['accountSlug', 'appSlug']),
    storageKey() {
      return getStorageKey(this.accountSlug, this.appSlug);
    },
    bannerMessage() {
      if (this.appName) {
        return `All Flows and Linked Apps built in ${this.appName} are accessible to all Shared Builders of this app`;
      }
      return 'All Flows and Linked Apps are accessible to all Shared Builders of this app';
    },
  },
  created() {
    this.isDismissed = localStorage.getItem(this.storageKey) === 'true';
  },
  methods: {
    dismiss() {
      localStorage.setItem(this.storageKey, 'true');
      this.isDismissed = true;
    },
  },
};
</script>
